import { LessonTypeType } from '../types';

export enum CourseStatusType {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'ACTIVE',
  COMPLETE = 'COMPLETE',
}

export enum CourseLessonType {
  LESSON = 'Lesson',
  UNIT_ASSESSMENT = 'Unit Assessment',
}

export interface Course {
  contentType: string;
  contentTypeId: number;
  description: string;
  featured: boolean;
  id: number;
  img: string;
  largeImg: string;
  lessonNumber: string;
  mediaData: string;
  points: number;
  required: boolean;
  scheduledHour: Date;
  sequence: number;
  sourceId: number;
  start: Date;
  status: CourseStatusType;
  title: string;
  transcript: string;
  type: CourseLessonType;
  url: string;
  locked: boolean;
  lessonType: LessonTypeType;
}
